import { render, staticRenderFns } from "./single-customer.vue?vue&type=template&id=d10f186a&scoped=true"
import script from "./single-customer.vue?vue&type=script&lang=js"
export * from "./single-customer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10f186a",
  null
  
)

export default component.exports